import { useState } from 'react';
import { TidalButton } from '../common/button';
import { JSONClient } from '../../api/bootstrap';

const DeleteItem = ({ onClose, itemId }) => {
  const [show, setShow] = useState(false);
  const [status, setStatus] = useState<any>('valid');
  const handleClose = () => {
    setShow(false);
    if (onClose) {
      onClose();
    }
  };
  const handleShow = () => {
    setShow(true);
  };

  const deleteItem = async () => {
    try {
      await JSONClient.delete(
        `${process.env.SHOP_BACKEND_URI}/market/item/${itemId}`,
      );
      handleClose();
    } catch (error) {
      setStatus(error?.response?.data);
    }
  };

  return (
    <div>
      <a
        className="text-red-500 hover:opacity-75"
        href="#"
        onClick={handleShow}
      >
        Delete
      </a>
      {show ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-1/3 my-3 mx-auto max-w-3xl">
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/*header*/}
                <div className="flex flex-col items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                  <div>
                    <p className="text-2xl font-semibold">
                      Are you sure you want to delete this item?
                    </p>
                  </div>
                </div>
                {/*footer*/}
                <div className="flex flex-wrap items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                  <div className="w-1/2">
                    <button
                      className="text-red-500 background-transparent font-bold px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="button"
                      onClick={handleClose}
                    >
                      Close
                    </button>
                  </div>
                  <div className="w-1/2">
                    <TidalButton
                      type="error"
                      tint={false}
                      text="Delete Item"
                      onClick={deleteItem}
                    />
                    {status !== 'valid' && (
                      <div className="w-full text-center pt-2">
                        <p>Failed to create item: {status?.message}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default DeleteItem;
